import { IFormHandler } from "./forms";
import { convertAmountToFloat } from "../helpers/transaction_helpers";

export interface IIncomeForm {
    name: string;
    amount: string;
}

export interface IIncomeRequest {
    name: string;
    amount: number;
}

export class IncomeForm implements IFormHandler<IIncomeForm, IIncomeRequest> {
    public readonly initialValue: IIncomeForm;

    constructor(data?: IIncomeRequest) {
        this.initialValue = this.toForm(data);
    }

    toForm(data?: IIncomeRequest): IIncomeForm {
        if (!data) {
            return {
                name: '',
                amount: '',
            };
        }

        return {
            name: data.name,
            amount: data.amount.toString(),
        };
    }

    toRequest(data: IIncomeForm): IIncomeRequest {
        return {
            name: data.name,
            amount: convertAmountToFloat(data.amount),
        };
    }
}
